module.exports = __webpack_public_path__ + "img/2.d7c54313.jpg";